
export default {
  props: {
    strokeWidth: { type: Number, default: 2 },
    stroke: { type: String, default: "black" },
  },
};
